import OpFilter from "./index.vue";
var opfilter = {
  install: function install(Vue) {
    Vue.component("OpFilter", OpFilter);
  }
};
export default opfilter;